export default __webpack_public_path__ + "static/media/fcf-logo-transparent.24eecc36.png";